<template>
    <div
        class="algolia-listing-product-block"
        itemscope
        itemtype="https://schema.org/Product"
    >
        <div class="d-md-none">
            <ProductImageActionLabel
                :action-label="item.action_label"
                v-if="item.action_label"
            />
        </div>
        <meta itemprop="sku" :content="item.ean13"/>
        <meta itemprop="description" :content="item.description_short"/>
        <div class="row">
            <div class="col-12 offset-lg-4 col-lg-8">
                <div
                    class="row algolia-listing-product-block__content-wrapper h-100"
                >
                    <div
                        class="col-12 col-md-8 algolia-listing-product-block__title-wrapper"
                    >
                        <a
                            :href="item.link_product"
                            :title="item.name"
                            @click="
                                sendClickEvent(`Product header Clicked on ${pageType} Page`)
                            "
                        >
                            <div class="d-md-none">
                                <ProductImage
                                    @click="
                                        sendClickEvent(
                                            `Product Image Clicked on ${pageType} Page`
                                        )
                                    "
                                    :action-label="item.action_label"
                                    :alert-label="item.alert_label"
                                    :product-url="item.link_product"
                                    :src="item.link_image"
                                />
                            </div>
                            <h2
                                class="algolia-listing-product-block__title"
                                itemprop="name"
                            >
                                {{ item.name }}
                            </h2>
                            <div
                                class="algolia-listing-product-block__product-information-wrapper"
                            >
                                <TrustPilotRating
                                    v-if="item.show_rating"
                                    :stars="item.stars"
                                    :rating="item.rating"
                                    :review-count="item.review_count"
                                    :link-to-product="item.link_product"
                                />
                            </div>
                        </a>
                        <div
                            class="algolia-listing-product-block__product-information-wrapper algolia-listing-product-block__product-information-wrapper--mobile"
                        >
                            <div>
                                <span
                                    class="algolia-listing-product-block__variant-count"
                                >{{ item.combinations_text }}
                                    {{
                                        $t("algoliaSearch.hitItemFromLabel")
                                    }}</span
                                ><br/>
                                <span
                                    class="algolia-listing-product-block__product-price algolia-listing-product-block__product-price--mobile"
                                    :class="{ 'algolia-listing-product-block__product-price--sale-red': item.price_tax_incl_from_is_discount }"
                                    v-text="item.price_tax_incl_from_display"
                                ></span>
                            </div>
                            <ProductCombinationsModal
                                :show-modal="showModal"
                                :item="item"
                                :lang-iso="langIso"
                                :page-type="pageType"
                                @buy="sendClickEvent(`Product Added to Cart from ${pageType} Page`)"
                                @out-of-stock="
                    sendClickEvent(
                        `Out of stock Product from ${pageType} Page`
                    )
                "
                            />
                        </div>
                    </div>
                    <a
                        :href="item.link_product"
                        :title='$t("algoliaSearch.hitItemViewProduct")'
                        class="col-12 col-md-4 algolia-listing-product-block__view-product-wrapper"
                        rel="noopener noreferrer"
                    >
                        <div
                            class="algolia-listing-product-block__view-product-button"
                        >
                            <span>{{
                                    $t("algoliaSearch.hitItemViewProduct")
                                }}</span>
                            <i class="fa fa-eye"></i>
                        </div>
                    </a>
                </div>
            </div>
            <a
                :href="item.link_product"
                :title="item.name"
                @click="
                    sendClickEvent(`Product image Clicked on ${pageType} Page`)
                "
                class="col-lg-4 d-none d-lg-block"
            >
                <ProductImageActionLabel
                    :action-label="item.action_label"
                    v-if="item.action_label"
                />
                <ProductImage
                    :action-label="item.action_label"
                    :alert-label="item.alert_label"
                    :product-url="item.link_product"
                    :src="item.link_image"
                />
            </a>

            <ProductCombinations
                :combinations="item.combinations"
                :id-product="item.id_product"
                :link-to-cart="item.link_to_cart"
                :lang-iso="langIso"
                @buy="
                    sendClickEvent(
                        `Product Added to Cart from ${pageType} Page`
                    )
                "
                @out-of-stock="
                    sendClickEvent(
                        `Out of stock Product from ${pageType} Page`
                    )
                "
            />
        </div>
    </div>
</template>

<script>
import TrustPilotRating from "../../ProductBlock/TrustPilotRating";
import ProductCombinations from "../../ProductBlock/ProductCombinations";
import ProductImage from "../../ProductBlock/ProductImage";
import ProductCombinationsModal from "../../ProductBlock/ProductCombinationsModal";
import TrustPilotRatingMobile from "../../ProductBlock/TrustPilotRatingMobile";
import ProductImageActionLabel from "../../ProductBlock/ProductImageActionLabel.vue";

export default {
    name: "HitItem",
    components: {
        ProductImageActionLabel,
        TrustPilotRatingMobile,
        ProductCombinationsModal,
        ProductImage,
        TrustPilotRating,
        ProductCombinations
    },
    data() {
        return {
            showModal: false,
        };
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        pageType: {
            type: String,
            required: false,
            default: "Category"
        },
        langIso: {
            type: String,
            required: false,
            default: "nl-NL"
        }
    },
    mounted() {
        if (document.getElementById("defaultSkeleton")) {
            document.getElementById("defaultSkeleton").style.display = "none";
        }
    },
    methods: {
        sendClickEvent(title) {
        },
    }
};
</script>
